export default {
    baseStyle: {
        formatPrice: {
            align: {
                display: 'inline-flex',
                gap: '4px',
                alignItems: 'center'
            }
        }
    }
}
